import { observer } from 'mobx-react';
import { ExperienceViewLogo } from '../../../../../../ProgramExperienceVideo';
import { ExperienceResource } from '../../../../../../Types';
import ExperienceVideoState from '../../../../../../../../ExperienceVideoState';

interface Props {
  experienceResource: ExperienceResource;
  className: string;
}

function ListProgramExperienceCardVideo({ experienceResource, className }: Props) {
  return (
    <ExperienceVideoState experienceResource={experienceResource} className={className}>
      <ExperienceViewLogo
        className={className}
        height={20}
        name={experienceResource.payload.school_partner_name}
        links={experienceResource.links}
      />
    </ExperienceVideoState>
  );
}

export default observer(ListProgramExperienceCardVideo);
